import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
    Card,
    CardActions,
    CardHeader,
    CardContent,
    Modal,
    Button,
    TextField
} from "@material-ui/core";
import { hot } from "react-hot-loader";
import { setEventRowTitle } from "./actions";

function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
        overflow: "visible"
    };
}

const styles = theme => ({
    paper: {
        position: "absolute",
        width: theme.spacing.unit * 55,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit,
        overflow: "visible"
    },

    margin: {
        margin: theme.spacing.unit
    }
});

class EditRowCellModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rowTitle: ""
        };
    }

    handleChange = e => {
        this.setState({ rowTitle: e.target.value });
    };

    componentDidUpdate = prevProps => {
        if (this.props.open !== prevProps.open && this.props.open === true) {
            this.setState({
                rowTitle: this.props.eventRow.title
            });
        }
    };

    render() {
        const { classes } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.props.open}
                onClose={this.props.handleClose}
            >
                <Card style={getModalStyle()} className={classes.paper}>
                    <CardHeader title={"Edit Row"} />
                    <CardContent>
                        <TextField
                            key={"rowTitle"}
                            id="outlined-name"
                            label="Name"
                            value={this.state.rowTitle}
                            onChange={this.handleChange}
                            margin="normal"
                            variant="outlined"
                            onKeyPress={event => {
                                if (event.key === "Enter") {
                                    this.props.setEventRowTitle(
                                        this.state.rowTitle,
                                        this.props.eventRowIndex
                                    );
                                    this.props.handleClose();
                                }
                            }}
                        />
                    </CardContent>
                    <CardActions
                        className={classes.actions}
                        disableActionSpacing
                    >
                        <Button
                            href="#text-buttons"
                            className={classes.button}
                            onClick={() => {
                                this.props.setEventRowTitle(
                                    this.state.rowTitle,
                                    this.props.eventRowIndex
                                );
                                this.props.handleClose();
                            }}
                        >
                            Save
                        </Button>
                        <Button
                            href="#text-buttons"
                            className={classes.button}
                            onClick={this.props.handleClose}
                        >
                            Cancel
                        </Button>
                    </CardActions>
                </Card>
            </Modal>
        );
    }
}

export default hot(module)(
    withStyles(styles)(
        connect(
            store => {
                return {};
            },
            { setEventRowTitle }
        )(EditRowCellModal)
    )
);
